import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { FindBaseUrlQueryQuery } from "../../../schemaTypes";

export const findBaseUrlQuery = gql`
  query FindBaseUrlQuery{
    findBaseUrl{
        baseUrl
    }
  }
`;

export interface WithFindBaseUrl {
  baseUrl: string
}

export function useFindBaseUrl() {
  const { data, loading } = useQuery<
    FindBaseUrlQueryQuery
  >(findBaseUrlQuery,
    {
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    baseUrl: data?.findBaseUrl?.baseUrl || null,
    loading
  };
}